<template>
    <ul class="sportList">
        <li v-if="title" class="sportList_catalog">
            {{ title }}
        </li>
        <SportListItem
            v-for="{ sport, icon } in sportsWithIcon"
            v-bind:key="sport.name"
            v-bind:sportInfo="sport"
        >
            <SboIcon
                v-if="icon?.type === 'sboIcon'"
                v-bind:name="icon.name"
                v-bind:size="icon.size"
                v-bind:style="{ color: 'initial' }"
            />
            <SvgIcon
                v-else-if="icon?.type === 'svg'"
                v-bind:name="icon.name"
                v-bind:size="icon.size"
                v-bind:style="icon.style"
            />
            <SportIcon
                v-else-if="sport.sportType"
                v-bind:sportType="sport.sportType"
                v-bind:size="16"
            />
        </SportListItem>
    </ul>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import SportListItem from './SportListItem.vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import SportIcon from '@/components/common/SportIcon.vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import type { ISportListIcon, ISportListItem } from '@/interface/ISport';

    const props = defineProps<{
        title?: string;
        items: ISportListItem[];
    }>();

    function getIcon(sport: ISportListItem): ISportListIcon | null {
        if (typeof sport.icon === 'string') {
            return { type: 'svg', name: sport.icon, size: 'md' };
        }
        return sport.icon ?? null;
    }

    const sportsWithIcon = computed(() => props.items.map(sport => ({
        sport,
        icon: getIcon(sport),
    })));
</script>

<style lang="scss" scoped>
    @import "@/components/sportList/SportList";
</style>
